import gql from 'graphql-tag';

export const SpaceAccessDetailsQuery = gql`
	query SpaceAccessDetailsQuery(
		$spaceKey: String!
		$first: Int
		$after: String
		$filterText: String
	) {
		space(key: $spaceKey) {
			id
			key
			name
			icon {
				path(type: ABSOLUTE)
				isDefault
			}
			type
		}
		spacePermissions(spaceKey: $spaceKey) {
			subjectsWithPermissions(first: $first, after: $after, filterText: $filterText) {
				groupCount
				userCount
				nodes {
					permissions
					subjectKey {
						id
						displayName
						principalType
						user {
							accountId
							displayName
							email
							permissionType
							profilePicture {
								width
								height
								isDefault
								path(type: ABSOLUTE)
							}
						}
						group {
							id
							name
							permissionType
						}
					}
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`;
